import React, { useEffect, useState, useContext } from "react";
import { initSchedule } from "../../../utils/data/initData";
import { AuthContext } from "../../../contexts/AuthContext";
import { useErrorDialog } from "../../../contexts/ErrorDialogContext";
import { useSuccessDialog } from "../../../contexts/SuccessDialogContext";
import ComponentLoading from "../../../components/App/ComponentLoading";
import { handleScheduleDeletion } from "../utils/handleScheduleDeletion";
import OtherIncomeSchedule from "../../../components/Schedules/Others/OtherIncomeSchedule";
import { PL_SCHEDULES } from "../../../utils/data/controlData";
import { useAccessControl } from "../../../utils/hooks/useAccessControl";

const ForeignTradeSchedulePage = ({ company, scheduleId }) => {
  const { updatePLSchedule, getScheduleData, deleteScheduleByScheduleType } =
    useContext(AuthContext);
  const [saveTrigger, setSaveTrigger] = useState(false);
  const [schedule, setSchedule] = useState({});
  const [scheduleDetails, setScheduleDetails] = useState({});

  const [loading, setLoading] = useState(true);

  const { canEdit: canEditPLSchedule } = useAccessControl(PL_SCHEDULES);

  const handleError = useErrorDialog();
  const handleSuccess = useSuccessDialog();

  const saveSchedule = async (schedule, scheduleDetails) => {
    if (!company || !scheduleId) {
      handleError("Unexpected error happens. Please try again later.");
      return;
    }

    const updatedSchedule = {
      sch_id: scheduleId,
      scheduleType: "Foreign_Trade",
      scheduleTitle: schedule.name,
      taxAdjustment: schedule.taxAdjustment,
      otherIncomeRows: scheduleDetails.otherIncomeRows,
      expensesRows: scheduleDetails.expensesRows,
      totalRevenue: scheduleDetails.totalRevenue,
      totalExpenses: scheduleDetails.totalExpenses,
      foreignTaxSuffered: scheduleDetails.foreignTaxSuffered,
      isTagToFTC: scheduleDetails.isTagToFTC,
      notes: schedule.notes,
      reviewNotes: schedule.reviewNotes,
      totalAdjustment: scheduleDetails.totalAdjustment,
      doc: scheduleDetails.doc,
    };

    //console.log("updatedSchedule", updatedSchedule);
    setLoading(true);
    //console.log(updatedSchedule);
    const response = await updatePLSchedule(updatedSchedule);
    setLoading(false);

    if (response) {
      handleSuccess("The schedule has been saved successfully.");
      setSaveTrigger((prev) => !prev);
    } else {
      handleError(
        "There was a problem saving the schedule. Please contact support if the issue persists."
      );
    }
  };

  const deleteSchedule = async () => {
    await handleScheduleDeletion({
      scheduleId,
      deleteFn: deleteScheduleByScheduleType,
      handleSuccess,
      handleError,
      setLoading,
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      if (!company || !scheduleId) {
        handleError(
          "We encountered an issue while fetching the data. Please refresh the page or try again shortly."
        );
        return;
      }
      //API call here
      const response = await getScheduleData(scheduleId, "Foreign_Trade");

      const scheduleData = response.schedule;

      //init
      if (scheduleData) {
        setSchedule(initSchedule(scheduleData, "Foreign Trade / Branch"));

        setScheduleDetails({
          otherIncomeRows: scheduleData.otherIncomeRows,
          expensesRows: scheduleData.expensesRows,
          foreignTaxSuffered: scheduleData.foreignTaxSuffered,
          isTagToFTC: scheduleData.isTagToFTC,
          schRef: scheduleData.schRef || null,
          foreignTaxCreditScheduleRef:
            scheduleData.foreignTaxCreditScheduleRef || null,
        });
      }

      setLoading(false);
    };
    fetchData();
  }, [saveTrigger, scheduleId, getScheduleData, company.uen, updatePLSchedule]);

  return (
    <>
      {loading ? (
        <ComponentLoading />
      ) : (
        <OtherIncomeSchedule
          company={company}
          schedule={schedule}
          scheduleDetails={scheduleDetails}
          saveSchedule={saveSchedule}
          deleteSchedule={deleteSchedule}
          canEditSchedule={canEditPLSchedule}
        />
      )}
    </>
  );
};

export default ForeignTradeSchedulePage;
